import { useLocation } from "react-router";
import { useState } from "react";
import axios from "axios";

const url = process.env.REACT_APP_API_URL + "/vehicles";

function EditVehicle() {
  const location = useLocation();
  const [manufacturer, setManufacturer] = useState("");
  const [name, setName] = useState("");
  const [cc, setCc] = useState("");
  const [type, setType] = useState("");

  /**
   * @desc Edit vehicle data
   */
  const editVehicle = async (vehicleId) => {
    const vehicle = {
      manufacturer: manufacturer || location.state.manufacturer,
      name: name || location.state.name,
      cc: cc || location.state.cc,
      type: type || location.state.type,
    };

    console.log("VEHICLE:", vehicle);

    try {
      if (JSON.parse(localStorage.getItem("fixit_user"))) {
        await axios.patch(`${url}/${vehicleId}`, vehicle, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("fixit_user")).token,
          },
        });
      }
    } catch (err) {
    }
  };

  return (
    <>
      <div style={{ marginTop: "7rem" }}>
        <form
          className="container p-3"
          style={{ border: "1px solid lightgray", borderRadius: "1rem" }}
        >
          <div className="mb-3">
            <label htmlFor="manufacturer" className="form-label fw-bold">
              Manufacturer
            </label>
            <input
              onChange={(e) => setManufacturer(e.target.value)}
              defaultValue={location.state.manufacturer}
              type="manufacturer"
              className="form-control"
              id="manufacturer"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="model" className="form-label fw-bold">
              Model
            </label>
            <input
              onChange={(e) => setName(e.target.value)}
              defaultValue={location.state.name}
              type="model"
              className="form-control"
              id="model"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="cc" className="form-label fw-bold">
              Cubic Capactiy
            </label>
            <input
              onChange={(e) => setCc(e.target.value)}
              defaultValue={location.state.cc}
              type="cc"
              className="form-control"
              id="cc"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="type" className="form-label fw-bold">
              Type
            </label>
            <input
              onChange={(e) => setType(e.target.value)}
              defaultValue={location.state.type}
              type="type"
              className="form-control"
              id="type"
            />
          </div>
          <div className="d-grid gap-2">
            <button
              onClick={() => editVehicle(location.state._id)}
              className="btn btn-warning"
              type="button"
            >
              Edit Vehicle
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default EditVehicle;
